export default __webpack_public_path__ + "static/media/valve_with_bg.fe912e92.svg";